export const getDateVerbose = (input: number | string | Date): string => {
  let time: number;

  if (typeof input === "number") {
    time = input;
  } else if (typeof input === "string") {
    let normalized = input.replace(" ", "T");
    if (!/[zZ]|([+\-]\d{2}:?\d{2})$/.test(normalized)) {
      normalized += "Z";
    }
    time = new Date(normalized).getTime();
  } else if (input instanceof Date) {
    time = input.getTime();
  } else {
    time = Date.now();
  }

  let seconds = Math.floor((Date.now() - time) / 1000);

  if (seconds < 0) {
    return new Date(time).toLocaleString("pt-BR");
  }

  const minute = 60;
  const hour = 3600;
  const day = 86400;
  const week = 604800;
  const month = 2592000;
  const year = 31536000;

  let value: number;
  let unit: string;

  if (seconds < hour) {
    value = Math.floor(seconds / minute) || 1;
    unit = value === 1 ? "minuto" : "minutos";
  } else if (seconds < day) {
    value = Math.floor(seconds / hour);
    unit = value === 1 ? "hora" : "horas";
  } else if (seconds < week) {
    value = Math.floor(seconds / day);
    unit = value === 1 ? "dia" : "dias";
  } else if (seconds < month) {
    value = Math.floor(seconds / week);
    unit = value === 1 ? "semana" : "semanas";
  } else if (seconds < year) {
    value = Math.floor(seconds / month);
    unit = value === 1 ? "mês" : "meses";
  } else {
    value = Math.floor(seconds / year);
    unit = value === 1 ? "ano" : "anos";
  }

  return `Atualizado há ${value} ${unit}`;
};
